import { create } from 'zustand'
import { v4 as uuid } from 'uuid'
import { subscribeWithSelector } from 'zustand/middleware'

const usePestelStore = create(
  subscribeWithSelector((set, get) => ({
    politic: {
      pestel_info: [
        {
          id: uuid(),
          loading: true,
        },
        {
          id: uuid(),
          loading: true,
        },
        {
          id: uuid(),
          loading: true,
        },
      ],
    },
    economic: {
      pestel_info: [
        {
          id: uuid(),
          loading: true,
        },
        {
          id: uuid(),
          loading: true,
        },
        {
          id: uuid(),
          loading: true,
        },
      ],
    },
    social: {
      pestel_info: [
        {
          id: uuid(),
          loading: true,
        },
        {
          id: uuid(),
          loading: true,
        },
        {
          id: uuid(),
          loading: true,
        },
      ],
    },
    technology: {
      pestel_info: [
        {
          id: uuid(),
          loading: true,
        },
        {
          id: uuid(),
          loading: true,
        },
        {
          id: uuid(),
          loading: true,
        },
      ],
    },
    environment: {
      pestel_info: [
        {
          id: uuid(),
          loading: true,
        },
        {
          id: uuid(),
          loading: true,
        },
        {
          id: uuid(),
          loading: true,
        },
      ],
    },
    law: {
      pestel_info: [
        {
          id: uuid(),
          loading: true,
        },
        {
          id: uuid(),
          loading: true,
        },
        {
          id: uuid(),
          loading: true,
        },
      ],
    },
    setField: (field, value) =>
      set((state) => ({
        ...state,
        [field]: {
          ...state[field],
          ...value,
          // pestel_info: state[field].pestel_info.map((sp, i) => ({
          //   ...sp,
          //   ...(value.pestel_info ? value.pestel_info[i] || {} : {}),
          // })),
          pestel_info: value.pestel_info.map((sp, i) => ({
            ...(state[field].pestel_info
              ? state[field].pestel_info[i] || {
                  id: uuid(),
                }
              : {
                  id: uuid(),
                }),
            ...sp,
          })),
        },
      })),
    updateFullPestel: (value) => set(() => value),
    updateFullPestelInfo: (field, value) =>
      set((state) => ({
        ...state,
        [field]: {
          ...state[field],
          pestel_info: state[field].pestel_info.map((pi, i) => ({
            ...pi,
            ...value[i],
          })),
        },
      })),
    updatePestelInfo: (field, id, key, value) =>
      set((state) => ({
        ...state,
        [field]: {
          ...state[field],
          pestel_info: state[field].pestel_info.map((info, index) =>
            index === id ? { ...info, loading: false, [key]: value } : info
          ),
        },
      })),
    updatePestelInfoById: (field, id, key, value) =>
      set((state) => ({
        ...state,
        [field]: {
          ...state[field],
          pestel_info: state[field].pestel_info.map((info) =>
            info.id === id ? { ...info, loading: false, [key]: value } : info
          ),
        },
      })),
    getPestelSubById: (field, id) => {
      const state = get()
      console.log(state)
      const target = state[field].pestel_info.find((info) => info.id === id)
      console.log(target.pestel_sub)
      return target.pestel_sub
      // get((state) => {
      //   console.log(id)
      //   console.log(state[field])
      //   const target = state[field].pestel_info.find((info) => info.id === id)
      //   return target.pestel_sub
      // })
    },
    removePestelInfo: (field, id) =>
      set((state) => ({
        ...state,
        [field]: {
          ...state[field],
          pestel_info: state[field].pestel_info.filter(
            (item, index) => index !== id
          ),
        },
      })),
    addPestelInfo: (field, id, obj) =>
      set((state) => {
        console.log(state[field].pestel_info)
        console.log(id)
        console.log(obj)
        state[field].pestel_info.splice(id, 0, obj)
        return {
          ...state,
          [field]: {
            ...state[field],
            pestel_info: state[field].pestel_info.map((p) => ({
              ...p,
              id: uuid(),
            })),
          },
        }
      }),
    init: () =>
      set((state) => ({
        ...state,
        politic: {
          pestel_info: [
            {
              id: uuid(),
              loading: true,
            },
            {
              id: uuid(),
              loading: true,
            },
            {
              id: uuid(),
              loading: true,
            },
          ],
        },
        economic: {
          pestel_info: [
            {
              id: uuid(),
              loading: true,
            },
            {
              id: uuid(),
              loading: true,
            },
            {
              id: uuid(),
              loading: true,
            },
          ],
        },
        social: {
          pestel_info: [
            {
              id: uuid(),
              loading: true,
            },
            {
              id: uuid(),
              loading: true,
            },
            {
              id: uuid(),
              loading: true,
            },
          ],
        },
        technology: {
          pestel_info: [
            {
              id: uuid(),
              loading: true,
            },
            {
              id: uuid(),
              loading: true,
            },
            {
              id: uuid(),
              loading: true,
            },
          ],
        },
        environment: {
          pestel_info: [
            {
              id: uuid(),
              loading: true,
            },
            {
              id: uuid(),
              loading: true,
            },
            {
              id: uuid(),
              loading: true,
            },
          ],
        },
        law: {
          pestel_info: [
            {
              id: uuid(),
              loading: true,
            },
            {
              id: uuid(),
              loading: true,
            },
            {
              id: uuid(),
              loading: true,
            },
          ],
        },
      })),
  }))
)

export default usePestelStore
